import { Token } from '@revolut-internal/ui-kit'

import {
  AssistantChatMessageRating,
  AuthorRole,
  CreateAssistantChatMessageFeedbackPayload,
} from 'lib/apiClient'

import { MessageColorSchema } from './ChatMessage.types'

interface GetMessageColorSchemaProps {
  messageType: AuthorRole
  isDebugView?: boolean
}

export function getMessageColorSchema({
  messageType,
  isDebugView,
}: GetMessageColorSchemaProps): MessageColorSchema {
  if (messageType === AuthorRole.Customer) {
    return {
      bgColor: Token.color.accent,
      text: Token.color.white,
      link: Token.color.white,
      date: Token.color.onAccent_60,
    }
  }

  if (messageType === AuthorRole.Agent && isDebugView) {
    return {
      bgColor: Token.color.segmentedBackground,
      text: Token.color.foreground,
      link: Token.color.foreground,
      date: Token.color.grey20,
    }
  }

  return {
    bgColor: Token.color.widgetBackground,
    text: Token.color.foreground,
    link: Token.color.foreground,
    date: Token.color.grey20,
  }
}

export function getAssistantChatMessageFeedbackPayload({
  rating,
  reasons,
  feedback,
  messageId,
}: {
  messageId: string
  rating: AssistantChatMessageRating
  feedback?: string
  reasons?: string[]
}): CreateAssistantChatMessageFeedbackPayload {
  return {
    assistantGenerationId: messageId,
    rating,
    feedback: feedback || null,
    reasons: reasons?.length ? reasons : null,
  }
}
